import { Resources } from 'constants/resources';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useListController } from 'react-admin';
import { ExportButton } from 'shared/react-admin/Buttons';
import { ListPage } from 'shared/react-admin/Pages';

import { UserActionsListContent } from './UserActionsListContent';

export const UserActionsList: React.FC = () => {
  const translate = useTypedTranslate();

  const { filterValues } = useListController({
    resource: Resources.UserActions,
    queryOptions: { enabled: false },
  });

  return (
    <ListPage
      actions={[<ExportButton key="export_user_actions" />]}
      empty={false}
      filter={filterValues}
      headerTitle={{
        titleText: translate('app.userActions.titleText'),
      }}
      sort={{ field: 'id', order: 'DESC' }}
    >
      <UserActionsListContent />
    </ListPage>
  );
};
